<template>
<v-row >
    <v-col cols="12">
        <v-row class="pb-5" >
            <template>
                <load-image-dialog :LoadImageDialogProps="LoadImageDialogProps" :companyId="companyId"/>
            </template>
        </v-row>
        <v-row style="position: relative" class="pl-6 pr-6">
          <v-col class="pr-1 pl-1 pb-4"
            v-for="(item, index) in galleryComponent"
            :key="index"
            cols="3"
          >
            <v-hover>
              <v-card hover light slot-scope="{hover}">
                <v-tooltip bottom>
                  <template v-slot:activator="{on}">
                    <v-img
                      @click="loadImage(index)"
                      :src="item.imageUrl === '' ? addImageIcon : item.imageUrl"
                      aspect-ratio="1"
                      contain
                      class="grey darken-2"
                      style="cursor:pointer"
                      v-on="on"
                      eager
                    />
                  </template>
                  <span>{{item.imageUrl === '' ? 'Agregar imagen' : 'Cambiar imagen'}}</span>
                </v-tooltip>
                <v-btn
                  v-show="hover"
                  @click="removeGalleryBlock(index)"
                  light
                  fab
                  small
                  absolute
                  style="top: 5px; right: 5px;"
                >X</v-btn>
                <v-row v-show="index + 1 === galleryComponent.length">
                  <v-tooltip bottom>
                    <template v-slot:activator="{on}">
                        <v-btn
                            @click="addGalleryImageBlock(index)"
                            dark
                            fab
                            small
                            absolute
                            icon
                            :color="mainColor"
                            v-on="on"
                          style="bottom: 0; right: -40px;"
                        ><v-icon>{{addIcon}}</v-icon>
                        </v-btn>
                    </template>
                    <span>Agregar tarjeta</span>
                  </v-tooltip>
                </v-row>
              </v-card>
            </v-hover>
          </v-col>
        </v-row>
    </v-col>
</v-row>
</template>
<script>
import * as constants from '../../../constants.json'
import { mdiPlusCircle } from '@mdi/js'

export default {
  props: ['gallery', 'rules', 'max1', 'max3', 'companyId'],
  data () {
    return {
      galleryComponent: this.gallery, // The gallery property sent from the main view.
      mainColor: constants.MAINCOLOR,
      style: {
        border: '1px solid #e1e1e1',
        fontColor: '#525252'
      },
      imageIndex: null, // Auxiliar index to poit to the actual content block to upload the new image.
      addImageIcon: constants.ADD_IMAGE_ICON,
      LoadImageDialogProps: { loadDialog: false, imageUrl: null },
      addIcon: mdiPlusCircle
    }
  },

  watch: {
    /**
         * If a new image has been loaded, we add it to the correspondent property.
         */
    'LoadImageDialogProps.imageUrl': function (val) {
      // eslint-disable-next-line
            console.log('this.imageIndex', this.imageIndex )
      this.galleryComponent[this.imageIndex].imageUrl = this.LoadImageDialogProps.imageUrl
    }
  },

  methods: {
    /**
         * Add a new gallery block
         */
    addGalleryImageBlock (index) {
      // Don't add anything if there is no selection
      if (this.galleryComponent[index].imageUrl === '') {
        return
      }
      // Push an empty element
      this.galleryComponent.push({
        imageUrl: ''
      })
    },

    /**
     * Remove gallery block
     */
    removeGalleryBlock (index) {
      if (index === 0 && this.galleryComponent.length === 1) {
        this.galleryComponent[0].imageUrl = ''
      } else {
        this.galleryComponent.splice(index, 1)
      }
    },

    /**
         * Call the load-image-dialog component
         */
    loadImage (index) {
      this.imageIndex = index
      this.LoadImageDialogProps.loadDialog = true
    }
  }
}
</script>
